import { Input } from "../ui/input";
import { Switch } from "../ui/switch";
import { Label } from "../ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { GROUP_META, presetRange } from "./definitions";

const PRESETS = [
  { value: "7d", label: "Last 7 days" },
  { value: "30d", label: "Last 30 days" },
  { value: "quarter", label: "This quarter" },
  { value: "custom", label: "Custom" },
];

const FilterSelect = ({ value, onChange, placeholder, items, testId, width = "w-[160px]" }) => (
  <Select value={value || "all"} onValueChange={onChange}>
    <SelectTrigger className={`${width} h-9 bg-white text-sm`} data-testid={testId}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent>
      <SelectItem value="all">{placeholder}</SelectItem>
      {items.map((it) => (
        <SelectItem key={it.value} value={it.value}>{it.label}</SelectItem>
      ))}
    </SelectContent>
  </Select>
);

export const FiltersBar = ({ filters, setFilters, options }) => {
  const set = (patch) => setFilters((f) => ({ ...f, ...patch }));
  const onPreset = (preset) => set(preset === "custom" ? { preset } : { preset, ...presetRange(preset) });
  const opt = (arr) => (arr || []).map((v) => ({ value: v, label: v }));

  return (
    <div className="flex flex-wrap items-center gap-2 p-3 rounded-xl border border-slate-200 bg-white" data-testid="metrics-filters">
      <Select value={filters.preset} onValueChange={onPreset}>
        <SelectTrigger className="w-[140px] h-9 bg-white text-sm" data-testid="filter-date-preset"><SelectValue /></SelectTrigger>
        <SelectContent>
          {PRESETS.map((p) => <SelectItem key={p.value} value={p.value}>{p.label}</SelectItem>)}
        </SelectContent>
      </Select>
      {filters.preset === "custom" && (
        <div className="flex items-center gap-1">
          <Input type="date" value={filters.start} max={filters.end} onChange={(e) => e.target.value && set({ start: e.target.value })}
            className="h-9 w-[145px] text-sm" data-testid="filter-start-date" />
          <span className="text-slate-400 text-sm">–</span>
          <Input type="date" value={filters.end} min={filters.start} onChange={(e) => e.target.value && set({ end: e.target.value })}
            className="h-9 w-[145px] text-sm" data-testid="filter-end-date" />
        </div>
      )}
      <div className="flex items-center gap-2 px-2">
        <Switch id="compare" checked={filters.compare} onCheckedChange={(v) => set({ compare: v })} data-testid="filter-compare-toggle" />
        <Label htmlFor="compare" className="text-sm text-slate-600">Compare to previous period</Label>
      </div>
      <div className="flex flex-wrap items-center gap-2 lg:ml-auto">
        <FilterSelect value={filters.company} onChange={(v) => set({ company: v })} placeholder="All clients"
          items={opt(options.companies)} testId="filter-company" width="w-[170px]" />
        <FilterSelect value={filters.topic} onChange={(v) => set({ topic: v })} placeholder="All topics"
          items={opt(options.topics)} testId="filter-topic" />
        <FilterSelect value={filters.priority} onChange={(v) => set({ priority: v })} placeholder="All priorities"
          items={opt(options.priorities)} testId="filter-priority" width="w-[140px]" />
        <FilterSelect value={filters.group} onChange={(v) => set({ group: v })} placeholder="All groups"
          items={Object.entries(GROUP_META).map(([value, m]) => ({ value, label: m.label }))} testId="filter-group" />
      </div>
    </div>
  );
};
